/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.SocialMedia = function( xml, element) {
    var FxEvent = expocadfx.fxevent;
    
    var i = 0;
    var nodes = xml.childNodes[0].childNodes;
    var len = nodes.length;
    var node;
    var btn;
    var img;
    var list = document.createElement( "section");
    list.setAttribute( "id", "smc");
    var numLoaded = 0;
    var buttonCount = 0;
    
    for( i = 0; i < len; i++) {
        node = nodes[i];
        if( node.nodeType === 1 && node.tagName === "tool") {
            buttonCount += 1;
            btn = document.createElement( "a");
            img = document.createElement( "img");

            btn.href = node.getAttribute( "url");
            btn.style.textDecoration ="none";
            btn.target =  "_blank";

            img.setAttribute( "class", "smb");
            img.src = node.getAttribute( "icon");
            img.alt = node.getAttribute( "name");
            btn.title = img.alt;
            img.addEventListener( "load", imgDone);
            img.addEventListener( "error", imgDone);
            
            btn.appendChild( img);
            list.appendChild( btn);
        }
    }
    element.appendChild( list);
    
    function imgDone( evt) {
        numLoaded += 1;
        evt.target.removeEventListener( "load", imgDone);
        evt.target.removeEventListener( "error", imgDone);
        
        if( numLoaded === buttonCount) {
            document.dispatchEvent( new FxEvent( "Size_Change", { "element": "social"}));
        }
    }
};